import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import InfoIcon from "@material-ui/icons/Info";
import FlagIcon from "@material-ui/icons/Flag";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import classNames from "classnames";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { withTranslation } from "react-i18next";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { Badge } from "@material-ui/core";
import SidebarDiscussions from "../discussions/SidebarDiscussions";
import SidebarRework from "../rework/SidebarRework";
import StarIcon from "@material-ui/icons/Star";
import GetAppIcon from "@material-ui/icons/GetApp";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import SchoolIcon from "@material-ui/icons/School";
import { currentUserHasRole, Role } from "../../utils/RoleUtils";
import "@mdi/font/css/materialdesignicons.min.css";
import FilterWrapper from "../filter/FilterWrapper";
import axios from "../../AxiosClient";
import SidebarEdit from "../content/SidebarEdit";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import SidebarWorkflow from "../content/sidebar/SidebarWorkflow";
import SidebarPDF from "../content/sidebar/SidebarPDF";
import SidebarRelatedDocuments from "../content/sidebar/SidebarRelatedDocuments";
import SidebarDiff from "../content/sidebar/SidebarDiff";
import CompareIcon from "@material-ui/icons/Compare";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import Icon from "@mdi/react";
import { mdiFileLink } from "@mdi/js";
import { withSnackbar } from "notistack";
import { isOfficeMime } from "../content/MimeTypeHelper";
import SidebarInfo from "./SidebarInfo";
import { withRouter } from "react-router";
import { Typography } from "@material-ui/core";
import SearchResolution from "../search/SearchResolution";
import PropertyNames from "../../PropertyNames";

const drawerWidth = 350;

const styles = (theme) => ({
  sidebarContainer: {
    display: "flex",
    overflow: "hidden",
    height: "100%",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    // whiteSpace: 'nowrap',
    height: "100%",
    overflow: "visible",
    zIndex: 1,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    overflowX: "hidden",
    textOverflow: "ellipsis",
    // overflow: 'visible',
    height: "100%",
  },
  srOnly: {
    position: "absolute",
    left: "-10000px",
    width: "1px",
    height: "1px",
    overflow: "hidden",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // overflowX: 'hidden',
    textOverflow: "ellipsis",
    // overflow: 'visible',
    width: theme.spacing(6) + 1,
    "& #sidebarContent": {
      // display: 'none',
    },
    position: "relative",
    height: "100%",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(6),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: theme.spacing(6) + 6,
    height: "100%",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  sidebarIcon: {
    display: "block",
  },
  sidebarContent: {
    width: drawerWidth - 48,
    height: "100%",
    // overflow: "auto",
  },
  infoTable: {
    marginTop: "20px",
  },
  sidebarCard: {
    boxShadow: "none",
  },
  cardContent: {
    // display: 'flex',
    // flexDirection: 'column',
    // height: '100%',
    // overflowY: 'scroll',
  },
  formControl: {
    marginBottom: 10,
  },
});

export class DocumentSidebar extends Component {
  constructor(props) {
    super(props);
    this.makeFavourite = this.makeFavourite.bind(this);
    this.likeDocument = this.likeDocument.bind(this);
  }
  static propTypes = {
    documentId: PropTypes.number.isRequired,
    onCloseDiscussions: PropTypes.func.isRequired,
  };

  state = {
    sidebarOpen: false,
    showDiscussions: false,
    showRework: false,
    showInfo: false,
    showWorkflow: false,
    showPDF: false,
    showDiff: false,
    showRelatedDocuments: false,
    labelWidth: 0,
    documentData: {},
    viewingStatsJson: null,
    unreadDiscussions: 0,
    resolutionId: "",
    filters: {
      status: "OPEN",
      sort: "urgency",
      sortOrder: "DESC",
      urgency: "All",
      authoredByMe: false,
      raisedByMe: false,
      taxonomyId: 0,
      knowledgeSourceId: 0,
      documentId: 0,
      includeUnattached: true,
      taxonomyNode: { name: "" },
    },
    showFilters: false,
    filterAnchorEl: null,
    requiredReadingHighlight: true,
    showRequiredReading: false,
    requiredReadingIds: null,
    countOfRelatedDocuments: 0,
  };

  componentDidMount() {
    let discussionsEnabled =
      this.props.applicationProperties[PropertyNames.DISCUSSIONS_ENABLED] ===
      "true";
    if (
      this.props.location.state &&
      this.props.location.state.discussionId &&
      discussionsEnabled
    ) {
      this.setState({ sidebarOpen: true });
      this.openWithDiscussions();
    }
    this.props.documentMeta
      ? this.setState(
          { documentData: this.props.documentMeta.documentRVO },
          () => this.getRRData()
        )
      : this.getData();
    if (this.props.openFromPortlet != null) {
      this.setState({
        sidebarOpen: true,
        showDiscussions: discussionsEnabled ? true : false,
        showRework: false,
      });
    }
    if (this.props.diffRecent) {
      this.setState({ sidebarOpen: true, showDiff: true });
    }
    if (this.props.documentId) {
      let filters = {...this.state.filters, documentId: this.props.documentId,}
      this.setState({filters: filters})
    }
  }

  getData = () => {
    if (this.props.documentId) {
      axios
        .get(`/document/${this.props.documentId}`, { withCredentials: true })
        .then((res) => {
          this.setState({ documentData: res.data });
        });
      this.getRRData();
    }
  };
  getRRData = () => {
    axios.post(`/requiredreading/alerted?page=0&size=1000`, {}).then((res) => {
      let rrIds = [];
      res.data.content.forEach((rr) => {
        let docUnread = rr.requiredReadingDocuments.filter((d) => {
          return d.documentID === this.props.documentId && !d.read;
        });
        if (docUnread.length > 0) {
          rrIds.push(rr.id);
        }
      });
      if (rrIds.length > 0) {
        this.setState({ showRequiredReading: true, requiredReadingIds: rrIds });
      }
      // res.data.content.filter((requiredReading) => {
      //   this.setState({ requiredReadingId: requiredReading.id });
      //   requiredReading.requiredReadingDocuments.filter((e) => {
      //     if (e.documentID === this.props.documentId && !e.read) {
      //       this.setState({ showRequiredReading: true });
      //     }
      //   });
      // });
    });
  };

  componentDidUpdate(prevProps, prevState) {
    let discussionsEnabled =
      this.props.applicationProperties[PropertyNames.DISCUSSIONS_ENABLED] ===
      "true";
    if (
      this.props.location.state !== prevProps.location.state &&
      this.props.location.state &&
      this.props.location.state.resolutions &&
      this.props.location.state.resolutions.indexOf(this.state.resolutionId) < 0
    ) {
      this.setState({ resolutionId: "" });
    }
    if (
      prevProps.editContent != this.props.editContent &&
      this.props.editContent === true
    ) {
      this.setState({ showRework: true, sidebarOpen: true });
    }
    if (
      this.props.documentId !== prevProps.documentId &&
      this.props.documentId
    ) {
      this.setState({ sidebarOpen: false });
      this.getData();
    }
    if (
      this.state.showReworks &&
      this.state.showReworks !== prevState.showReworks
    ) {
      //this.getReworks();
    }
    if (
      prevProps.diffRecent !== this.props.diffRecent &&
      this.props.diffRecent
    ) {
      this.setState({ sidebarOpen: true, showDiff: true });
    }
    if (
      prevProps.location.state !== this.props.location.state &&
      this.props.location.state.discussionId
    ) {
      if (!this.state.sidebarOpen && discussionsEnabled) {
        this.setState({ sidebarOpen: true });
        this.openWithDiscussions();
      }
    }
  }

  getWorkflowTooltip = () => {
    switch (this.props.workflowState) {
      case "AWAITING_REVIEW":
        return this.props.t("document_awaiting_review");
      case "AWAITING_APPROVAL":
        return this.props.t("document_awaiting_approval");
      case "AWAITING_PUBLISH":
        return this.props.t("document_awaiting_publish");
      default:
        return this.props.t("global_workflow");
    }
  };

  render() {
    const { classes, t } = this.props;
    let currentPath = this.props.match.url;
    let discussionEnabled =
      this.props.applicationProperties[PropertyNames.DISCUSSIONS_ENABLED] ===
      "true";
    let drawerCtrl = (
      <Drawer
        variant="permanent"
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: this.state.sidebarOpen,
          [classes.drawerClose]: !this.state.sidebarOpen,
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: this.state.sidebarOpen,
            [classes.drawerClose]: !this.state.sidebarOpen,
          }),
          paperAnchorLeft: null,
        }}
        open={this.state.sidebarOpen}
      >
        <div id="sidebarContainer" className={classes.sidebarContainer}>
          <div className={classes.drawerHeader}>
            {/* <IconButton onClick={this.toggleSidebar} className={classes.sidebarIcon}>
          {this.state.sidebarOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton> */}
            {!this.props.isRevision &&
              this.props.currentUser.userType != "limited" &&
              discussionEnabled && (
                <Tooltip
                  title={
                    <Typography>{t("global_discussion_plural")}</Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    onClick={this.openWithDiscussions}
                    className={classes.sidebarIcon}
                    aria-label="Discussions"
                  >
                    <Badge
                      color="secondary"
                      badgeContent={this.state.unreadDiscussions}
                    >
                      <QuestionAnswerIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )}
            {this.props.internalDocument &&
              !this.props.isRevision &&
              (currentUserHasRole(Role.BE_EXPERT) ||
                currentUserHasRole(Role.REWORKER)) && (
                <Tooltip
                  title={
                    <Typography>{t("document_flag_for_rework")}</Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    id="rework-request"
                    onClick={this.openWithRework}
                    className={classes.sidebarIcon}
                    aria-label="Reworks"
                  >
                    <Badge
                      color="secondary"
                      badgeContent={
                        this.props.internalDocument.contentRVO.openReworks
                      }
                    >
                      <FlagIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              )}
            {!this.props.isRevision && (
              <>
                {this.state.documentData &&
                this.state.documentData.favourite ? (
                  <Tooltip
                    title={<Typography>{t("document_unfavourite")}</Typography>}
                    placement="left"
                  >
                    <IconButton
                      id="unfavourite-document"
                      onClick={this.makeFavourite}
                      className={classes.sidebarIcon}
                      aria-label="Remove from favourites"
                    >
                      <StarIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <div>
                    <Tooltip
                      title={
                        <Typography>{t("document_make_favourite")}</Typography>
                      }
                      placement="left"
                    >
                      <IconButton
                        id="favourite-document"
                        onClick={this.makeFavourite}
                        className={classes.sidebarIcon}
                        aria-label="Favourite"
                      >
                        <StarBorderIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </>
            )}
            {!this.props.isRevision && (
              <>
                {this.state.documentData && !this.state.documentData.myLiked ? (
                  <Tooltip
                    title={<Typography>{t("document_like")}</Typography>}
                    placement="left"
                  >
                    <IconButton
                      id="like-document"
                      onClick={this.likeDocument}
                      className={classes.sidebarIcon}
                      aria-label="Like"
                    >
                      <ThumbUpIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={<Typography>{t("document_unlike")}</Typography>}
                    placement="left"
                  >
                    <IconButton
                      id="unlike-document"
                      onClick={this.likeDocument}
                      className={classes.sidebarIcon}
                      aria-label="Unlike"
                    >
                      <ThumbDownIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
            {!this.props.isRevision && (
              <Tooltip
                title={<Typography>{t("global_info")}</Typography>}
                placement="left"
              >
                <IconButton
                  id="document-info"
                  onClick={this.openWithInfo}
                  className={classes.sidebarIcon}
                  aria-label="Info"
                >
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )}
            {!this.props.isRevision &&
              this.state.showRequiredReading &&
              (!this.state.requiredReadingHighlight ? (
                <Tooltip
                  title={
                    <Typography>
                      {t("mark_required_reading_as_read")}
                    </Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    disabled
                    className={classes.sidebarIcon}
                    aria-label="Mark as read"
                  >
                    <MenuBookIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  title={
                    <Typography>
                      {t("mark_required_reading_as_read")}
                    </Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    id="mark-required-reading-as-read"
                    color="secondary"
                    onClick={this.markRequiredReadingAsRead}
                    className={classes.sidebarIcon}
                    aria-label="Mark as read"
                  >
                    <MenuBookIcon />
                  </IconButton>
                </Tooltip>
              ))}
            {this.props.workflowState && 
            (this.props.currentUser.userPermits.roles.beExpert ||
              this.props.currentUser.userPermits.roles.reviewer ||
              this.props.currentUser.userPermits.roles.approver ||
              this.props.currentUser.userPermits.roles.publisher ) && (
              <>
                <Tooltip
                  title={<Typography>{this.getWorkflowTooltip()}</Typography>}
                  placement="left"
                >
                  <IconButton
                    id="revision-workflow"
                    onClick={this.openWithWorkflow}
                    className={classes.sidebarIcon}
                    aria-label="Workflow"
                  >
                    {(this.props.workflowState === "PUBLISHED" ||
                      this.props.workflowState === "SUPERCEDED") &&
                    !this.props.internalDocument.hasDraft ? (
                      <AssignmentLateIcon />
                    ) : (
                      <Badge color="secondary" variant="dot">
                        <AssignmentLateIcon />
                      </Badge>
                    )}
                  </IconButton>
                </Tooltip>
              </>
            )}
            {this.props.internalDocument &&!this.props.currentUser.userPermits.roles.limitedUser && (
              <>
                <Tooltip
                  title={<Typography>{t("diff_revisions_tooltip")}</Typography>}
                  placement="left"
                >
                  <IconButton
                    id="document-revisions"
                    onClick={this.openWithDiff}
                    className={classes.sidebarIcon}
                    aria-label="Revision differences"
                  >
                    <CompareIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
            {this.props.isSearch && (
              <>
                <Tooltip
                  title={
                    <Typography>{t("maximise_document_tooltip")}</Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    id="maximise-document-viewer"
                    onClick={this.maximise}
                    className={classes.sidebarIcon}
                    aria-label="Maximise document viewer"
                  >
                    <OpenInBrowserIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
            {/* {this.props.location &&
              this.props.location.state &&
              this.props.location.state.searchId &&
              this.props.location.state.position &&
              this.props.location.state.score && (
                <SearchResolution
                  searchId={this.props.location.state.searchId}
                  documentId={this.props.documentId}
                  onResolution={this.props.onResolution}
                  onUnResolved={this.props.onUnResolved}
                  position={this.props.location.state.position}
                  score={this.props.location.state.score}
                />
              )} */}
            {((this.props.internalDocument &&
              this.props.internalDocument.contentRVO.fileId) ||
              (this.props.documentMeta &&
                this.props.documentMeta.documentRVO &&
                !this.props.currentUser.userPermits.roles.limitedUser && 
                isOfficeMime(
                  this.props.documentMeta.documentRVO.contentType
                ))) && (
              <Tooltip
                title={
                  <Typography>{t("download_original_tooltip")}</Typography>
                }
                placement="left"
              >
                <IconButton
                  onClick={this.downloadOriginal}
                  className={classes.sidebarIcon}
                  aria-label="Download original file"
                >
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
            )}
            {!this.props.isRevision &&
              this.props.internalDocument && 
              !this.props.currentUser.userPermits.roles.limitedUser && (
                // !this.props.internalDocument.contentRVO.file
                //   .failedToGetContent &&
                <>
                  <Tooltip
                    title={<Typography>{t("sidebar_pdf_export")}</Typography>}
                    placement="left"
                  >
                    <IconButton
                      id="document-sidebar-export-as-pdf"
                      onClick={this.openWithPDF}
                      className={classes.sidebarIcon}
                      aria-label="Export as PDF"
                    >
                      <PictureAsPdfIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            {!this.props.isRevision && !this.props.currentUser.userPermits.roles.limitedUser && (
              <Tooltip
                title={
                  <Typography>{t("related_documents_tooltip")}</Typography>
                }
                placement="left"
              >
                <IconButton
                  id="related-documents"
                  onClick={this.openWithRelatedDocuments}
                  className={classes.sidebarIcon}
                  aria-label="Related documents"
                >
                  <Badge
                    color="secondary"
                    badgeContent={this.state.countOfRelatedDocuments}
                  >
                    <Icon path={mdiFileLink} size={1} />
                  </Badge>
                </IconButton>
              </Tooltip>
            )}
            {this.props.internalDocument &&
              !this.props.isRevision &&
              !this.props.isMobile &&
              currentUserHasRole(Role.BE_EXPERT) &&
              this.props.internalDocument.userIsTopicExpert && (
                <Tooltip
                  title={
                    <Typography>{t("document_view_knowledge_item")}</Typography>
                  }
                  placement="left"
                >
                  <IconButton
                    id="view-knowledge-item"
                    onClick={() => {
                      this.props.history.push(
                        "/full/knowledgeitem/" +
                          this.props.internalDocument.contentRVO.itemId
                      );
                    }}
                    className={classes.sidebarIcon}
                    aria-label="View Knowledge Item"
                  >
                    <SchoolIcon />
                  </IconButton>
                </Tooltip>
              )}
          </div>
          <div
            id="sidebarContent"
            className={classes.sidebarContent}
            role="complementary"
          >
            {this.props.currentUser.userType != "limited" &&
              discussionEnabled && 
                this.props.documentId && (
                  <SidebarDiscussions
                    documentData={this.state.documentData}
                    toggleSidebar={this.toggleSidebar}
                    show={this.state.showDiscussions}
                    showDiscussions={this.state.showDiscussions}
                    changeOpenCreateDiscussion={this.changeOpenCreateDiscussion}
                    documentId={parseInt(this.props.documentId)}
                    knowledgeSourceId={parseInt(
                      this.state.documentData
                        ? this.state.documentData.knowledgeSourceId
                        : 0
                    )}
                    itemId={
                      this.state.documentData
                        ? this.state.documentData.itemId
                        : -1
                    }
                    discussionId={
                      this.props.location.state
                        ? this.props.location.state.discussionId
                        : null
                    }
                    isPortlet
                    updateUnread={(value) =>
                      this.setState({ unreadDiscussions: value })
                    }
                  />
              )}
            {this.props.documentId &&
              <SidebarRelatedDocuments
                show={this.state.showRelatedDocuments}
                toggleSidebar={this.toggleSidebar}
                documentId={parseInt(this.props.documentId)}
                countOfRelatedDocuments={this.countRelatedDocuments}
              />
            }
            {this.state.showWorkflow && 
              (this.props.currentUser.userPermits.roles.beExpert ||
                this.props.currentUser.userPermits.roles.reviewer ||
                this.props.currentUser.userPermits.roles.approver ||
                this.props.currentUser.userPermits.roles.publisher ) && (
              <SidebarWorkflow
                show={this.state.showWorkflow}
                toggleSidebar={this.toggleSidebar}
                internalDocument={this.props.internalDocument}
                getDocumentContent={this.props.getDocumentContent}
                isRevision={this.props.isRevision}
                updateDocumentWorkflow={this.props.updateDocumentWorkflow}
              />
            )}
            <SidebarPDF
              show={this.state.showPDF}
              toggleSidebar={this.toggleSidebar}
              internalDocument={this.props.internalDocument}
            />
            <SidebarDiff
              show={this.state.showDiff}
              toggleSidebar={this.toggleSidebar}
              internalDocument={this.props.internalDocument}
              onRevisionClick={this.props.onRevisionDiffChange}
              diffRevisionNumber={this.props.diffRevisionNumber}
              diffRecent={this.props.diffRecent}
            />
            {this.props.documentId &&
              <SidebarInfo
                show={this.state.showInfo}
                toggleSidebar={this.toggleSidebar}
                documentData={this.state.documentData}
                documentId={parseInt(this.props.documentId)}
              />
            }
            {this.state.showRework && (
              <SidebarRework
                toggleSidebar={this.toggleSidebar}
                toggleFilters={this.toggleFilters}
                show={this.state.showRework}
                filter={this.state.filters}
                internalDocument={this.props.internalDocument}
                isPortlet
                isDraft={this.state.documentData.displayingDraft}
                editing={this.props.edit}
                updateResolvingReworks={this.props.updateResolvingReworks}
              />
            )}
            {this.props.edit && (
              <Card>
                <CardHeader
                  title={t("document_sidebar_edits")}
                  // action={
                  //   <>
                  //     <IconButton onClick={this.toggleFilters}>
                  //       <FilterListIcon />
                  //     </IconButton>
                  //     <IconButton onClick={this.toggleSidebar}>
                  //       <CloseIcon />
                  //     </IconButton>
                  //   </>
                  // }
                />
                <CardContent style={{ height: "50%" }}>
                  <SidebarEdit
                    documentId={parseInt(this.props.documentId)}
                    style={{ height: "100%" }}
                  />
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </Drawer>
    );

    return (
      <>
        <Typography component="h2" className={classes.srOnly}>
          {this.props.t("document_sidebar_header")}
        </Typography>
        {drawerCtrl}
        <FilterWrapper
          asPopper
          disablePortal
          open={this.state.showFilters}
          onClose={this.toggleFilters}
          anchorEl={this.state.filterAnchorEl}
          filterElement="FilterRework"
          filter={this.state.filters}
          onFilterChange={this.onFilterChange}
          isFilterBar={true}
          title={this.props.t("rework_filter_title")}
        />
      </>
    );
  }

  countRelatedDocuments = (number) => {
    this.setState({ countOfRelatedDocuments: number });
  };

  makeFavourite() {
    axios
      .patch(`/document/${this.props.documentId}`, {
        myLiked: this.state.documentData.myLiked,
        favourite: !this.state.documentData.favourite,
      })
      .then((res) => {
        if (!this.state.documentData.favourite) {
          this.props.enqueueSnackbar(
            this.props.t("document_favourited_success"),
            { variant: "success" }
          );
        } else {
          this.props.enqueueSnackbar(
            this.props.t("document_unfavourited_success"),
            { variant: "success" }
          );
        }
        this.setState({ documentData: res.data });
      });
  }

  likeDocument() {
    axios
      .patch(`/document/${this.props.documentId}`, {
        myLiked: !this.state.documentData.myLiked,
        favourite: this.state.documentData.favourite,
      })
      .then((res) => {
        if (!this.state.documentData.myLiked) {
          this.props.enqueueSnackbar(this.props.t("document_liked_success"), {
            variant: "success",
          });
        } else {
          this.props.enqueueSnackbar(this.props.t("document_unliked_success"), {
            variant: "success",
          });
        }
        this.setState({ documentData: res.data });
      });
  }

  markRequiredReadingAsRead = () => {
    let promises = [];
    this.state.requiredReadingIds.forEach((id) => {
      promises.push(
        axios.post(`/requiredreading/${this.props.documentId}/${id}`)
      );
    });
    Promise.all(promises).then(() => {
      this.props.enqueueSnackbar(
        this.props.t("required_reading_marked_as_read_success"),
        { variant: "success" }
      );
      this.setState({ requiredReadingHighlight: false });
    });
  };

  onFilterChange = (filter) => {
    this.setState({
      filters: filter,
    });
  };

  maximise = () => {
    this.props.history.push(`/full/document/${this.props.documentId}`, {
      searchId: this.props.searchId,
      position: this.props.position,
      score: this.props.score,
      resolutions: this.props.resolutions,
    });
  };

  downloadOriginal = () => {
    let url = `/document/${this.props.documentId}/original`;
    if (
      this.props.internalDocument &&
      this.props.internalDocument.contentRVO.fileId
    ) {
      url = `/document/file/${
        this.props.internalDocument.contentRVO.fileId
      }?selectedFormat=original`;
    }
    axios.get(url, { withCredentials: true }).then((res) => {
      let blob = new Blob();
      blob = new Blob([this.base64ToArrayBuffer(res.data.byteString)], {
        type: res.data.contentType,
      });
      const objectURL = URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.href = objectURL;
      link.download = res.data.fileName;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(objectURL);
      document.body.removeChild(link);
    });
  };

  base64ToArrayBuffer = (base64) => {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  };

  openWithDiscussions = () => {
    this.setState(
      {
        showDiscussions: true,
        showRework: false,
        showInfo: false,
        showWorkflow: false,
        showDiff: false,
        showRelatedDocuments: false,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openWithRework = () => {
    this.setState(
      {
        showDiscussions: false,
        showRework: true,
        showInfo: false,
        showWorkflow: false,
        showDiff: false,
        showRelatedDocuments: false,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openWithPDF = () => {
    this.setState(
      {
        showDiscussions: false,
        showRework: false,
        showInfo: false,
        showDiff: false,
        showWorkflow: false,
        showRelatedDocuments: false,
        showPDF: true,
      },
      () => this.openSidebar()
    );
  };

  openWithWorkflow = () => {
    this.props.doWorkflow();
    this.setState(
      {
        showDiscussions: false,
        showRework: false,
        showInfo: false,
        showDiff: false,
        showWorkflow: true,
        showRelatedDocuments: false,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openWithRelatedDocuments = () => {
    this.setState(
      {
        showDiscussions: false,
        showRework: false,
        showInfo: false,
        showDiff: false,
        showWorkflow: false,
        showRelatedDocuments: true,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openWithDiff = () => {
    this.props.doDiff();
    this.setState(
      {
        showDiscussions: false,
        showRework: false,
        showInfo: false,
        showWorkflow: false,
        showDiff: true,
        showRelatedDocuments: false,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openWithInfo = () => {
    this.setState(
      {
        showDiscussions: false,
        showRework: false,
        showDiff: false,
        showInfo: true,
        showWorkflow: false,
        showRelatedDocuments: false,
        showPDF: false,
      },
      () => this.openSidebar()
    );
  };

  openSidebar = () => {
    this.setState({ sidebarOpen: true });
  };

  toggleSidebar = () => {
    if (this.state.sidebarOpen) {
      this.props.reset();
      this.setState({
        showDiscussions: false,
        showRework: false,
        showDiff: false,
        showInfo: false,
        showWorkflow: false,
        showRelatedDocuments: false,
        showPDF: false,
        sidebarOpen: false,
      });
    } else {
      this.setState({ sidebarOpen: true });
    }
  };

  toggleFilters = (e) => {
    this.state.filterAnchorEl === null &&
      this.setState({ filterAnchorEl: e.currentTarget });
    this.setState((prev) => ({ showFilters: !prev.showFilters }));
  };
}

const mapStateToProps = (state) => ({
  apiLocation: state.setting.apiLocation,
  currentUser: state.user.currentUser,
  applicationProperties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
});

export default connect(
  mapStateToProps,
  null
)(
  withStyles(styles)(
    withTranslation()(withTheme(withRouter(withSnackbar(DocumentSidebar))))
  )
);
